var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',{staticClass:"py-4"},[_c('BaseHeadingAndText',{attrs:{"heading":"Donations","headingSize":"3xl","headingColor":"cdlpink","textSize":"xl"}}),_c('BaseTable',{attrs:{"table":_vm.table,"loading":!_vm.loaded}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }